import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "header-body" }

import { ref, watchEffect } from "vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const type = ref("success");

console.log("$route.name ", route.name);
watchEffect(() => {
	if (route.name === "Meet") {
		type.value = "moonstone";
	} else {
		type.value = "success";
	}
});
// const props = defineProps({
// 	type: {
// 		type: String,
// 		default: "success",
// 		description: "Header background type",
// 		required: false,
// 	},
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { [`bg-${type.value}`]: type.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})